import React, { useCallback } from 'react';

import { FormHoc, Select, TextArea } from '../../atoms/Form';
import { useDialog } from '../../atoms/Dialog';
import { ChatDomain, CsLpUzel, Faq, FaqBase, FaqBaseValidation, csLpUzelList, faqCreate, faqUpdate } from '../../../api';
import useApi from '../../../hooks/useApi';
import SendingContainer from '../../hoc/SendingContainer';

interface IFormOdpovedProps {
    data?: Faq
    domeny: ChatDomain[]
    domena?: Faq['domain_id']
    reload: () => void
}

function FormOdpoved({ data, domena, domeny, reload }: IFormOdpovedProps) {
    const { call: newFaq, sending: sendingN, error: errorN } = useApi<void, FaqBase>({});
    const { call: updFaq, sending: sendingU, error: errorU } = useApi<void, FaqBase>({});
    const { data: uzly, loading: loadingUzly } = useApi<CsLpUzel[], void>(csLpUzelList({ autoFetch: true }));

    const { closeDialog } = useDialog();

    const onSubmit = useCallback(
        async (values: any) => {
            let response;
            if (values?.id)
                response = await updFaq(faqUpdate(values.id, values))
            else
                response = await newFaq(faqCreate(values));

            if (response !== false) {
                reload();
                closeDialog();
            }
        },
        [closeDialog, newFaq, updFaq, reload]
    );

    return (
        <SendingContainer sending={sendingN || sendingU || loadingUzly} error={errorN || errorU}>

            <FormHoc
                onSubmit={onSubmit}
                defaultValues={{
                    ...data,
                    domain_id: data?.['domain_id'] === undefined ? domena : data['domain_id']
                }}
                validationSchema={FaqBaseValidation}
            >
                {
                    ({ submitHandler }) => (
                        <form
                            onSubmit={submitHandler}
                            noValidate>
                            <Select
                                name='domain_id'
                                label='Doména'
                                disabled={domena !== undefined}>
                                <option value='' disabled>-</option>
                                {
                                    domeny.map(item => (
                                        <option
                                            key={item.id}
                                            value={item.id}>
                                            {item.name}
                                        </option>
                                    ))
                                }
                            </Select>
                            <Select
                                name='node_id'
                                label='Číslo uzlu'>
                                <option value=''>Bez čísla uzlu</option>
                                {
                                    uzly?.map(item => (
                                        <option key={item.id} value={item.id}>{item.id} - {item.shorttext}</option>
                                    ))
                                }
                            </Select>
                            <TextArea
                                name='answer'
                                label='Odpověď' />
                            <button
                                id='form-answer-submit'
                                className='display-none' />
                        </form>
                    )
                }
            </FormHoc>
        </SendingContainer>
    );
}

export default FormOdpoved;
